import { createComponent } from "../utils";

export default createComponent({
  name: "Unit Vector",
  group: "Vector",
  icon: () => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 474 335"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M319.12 6.51004C316.097 2.88114 311.683 0.693643 306.968 0.482743C302.249 0.267903 297.659 2.04915 294.32 5.38895C290.98 8.72875 289.199 13.3187 289.414 18.034C289.625 22.7528 291.812 27.1628 295.441 30.1859L416.251 151.136H16.9312C11.1265 151.445 5.89217 154.718 3.07617 159.804C0.259767 164.886 0.259767 171.062 3.07617 176.144C5.89257 181.226 11.127 184.499 16.9312 184.808H416.251L295.251 305.618C292.208 308.806 290.509 313.048 290.509 317.458C290.509 321.868 292.208 326.106 295.251 329.298C298.388 332.443 302.65 334.212 307.091 334.212C311.536 334.212 315.794 332.443 318.931 329.298L468.581 179.648C471.8 176.55 473.62 172.273 473.62 167.808C473.62 163.339 471.8 159.066 468.581 155.968L319.12 6.51004Z"
        fill="currentColor"
      />
    </svg>
  ),
  controls: [
    {
      id: "direction",
      name: "Direction",
      type: "Text",
      Render: ({ value = "x", onChange = () => null }) => {
        return (
          <div>
            <button
              style={{
                cursor: "pointer",
                border: 0,
                borderRadius: "4px",
                background: value === "x" ? "blue" : "white",
                color: value === "x" ? "white" : "black",
              }}
              onClick={() => onChange("x")}
            >
              X
            </button>
            <button
              style={{
                cursor: "pointer",
                border: 0,
                borderRadius: "4px",
                background: value === "y" ? "blue" : "white",
                color: value === "y" ? "white" : "black",
              }}
              onClick={() => onChange("y")}
            >
              Y
            </button>
            <button
              style={{
                cursor: "pointer",
                border: 0,
                borderRadius: "4px",
                background: value === "z" ? "blue" : "white",
                color: value === "z" ? "white" : "black",
              }}
              onClick={() => onChange("z")}
            >
              Z
            </button>
          </div>
        );
      },
    },
  ],
  inputs: [
    {
      id: "value",
      name: "Value",
      type: "Number",
    },
  ],
  outputs: [
    {
      id: "result",
      name: "Result",
      type: "Number",
      compute: ({ value = 1 }, { direction = "x" }) => {
        if (direction === "x") {
          return [value, 0, 0];
        }
        if (direction === "y") {
          return [0, value, 0];
        }
        if (direction === "z") {
          return [0, 0, value];
        }
      },
    },
  ],
});
